var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('x-navbar'),_c('main',{staticClass:"site-content"},[_vm._t("default")],2),_c('x-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }